import { render, staticRenderFns } from "./LiquidoPenetranteModal.vue?vue&type=template&id=fb098a56&scoped=true"
import script from "./LiquidoPenetranteModal.vue?vue&type=script&lang=js"
export * from "./LiquidoPenetranteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb098a56",
  null
  
)

export default component.exports